import { Pressable, SxProp, View } from "dripsy";
import React, { useEffect, useState } from "react";

import { TextBody } from "../typography/UniTypography";

export interface UniCheckboxItem {
  value: unknown;
  label: string;
}

export interface UniCheckboxTagProps extends UniCheckboxItem {
  isChecked: boolean;
  onChange: (value: unknown) => void;
}

export interface UniCheckboxTagGroupProps {
  label: string;
  items: Array<UniCheckboxItem>;
  values?: unknown;
  onValuesChange: (values: unknown) => void;
}

export const UniCheckboxTagGroup: React.FC<UniCheckboxTagGroupProps> = (
  props
) => {
  const { label, items, values, onValuesChange } = props;

  const [selectedValues, setSelectedValues] = useState<unknown>([]);

  useEffect(() => {
    setSelectedValues(values);
  }, []);

  useEffect(() => {
    onValuesChange(selectedValues);
  }, [selectedValues]);

  const onChange = (value: unknown) => {
    let newValues = [...selectedValues];
    if (value === undefined) {
      newValues = [];
    } else if (newValues.includes(value)) {
      newValues = newValues.filter((v) => v !== value);
    } else {
      newValues.push(value);
    }
    setSelectedValues(newValues);
  };

  return (
    <View sx={sxUniCheckboxTagGroupStyles.container}>
      <TextBody secondary label sx={{ ml: 4 }}>
        {label}
      </TextBody>
      <View sx={sxUniCheckboxTagGroupStyles.optionsContainer}>
        {items.map((item, i) => (
          <UniCheckboxTag
            {...item}
            key={`uni-checkbox-tag-${label}-${i}`}
            isChecked={selectedValues?.includes(item.value) || false}
            onChange={onChange}
          />
        ))}
      </View>
    </View>
  );
};

const UniCheckboxTag: React.FC<UniCheckboxTagProps> = (props) => {
  const { value, label, isChecked, onChange } = props;

  const onPress = () => {
    onChange(value);
  };

  let style = sxUniCheckboxTagStyles.base;
  if (isChecked) {
    style = { ...style, ...sxUniCheckboxTagStyles.checked };
  }

  return (
    <Pressable onPress={onPress} sx={style}>
      <TextBody color={isChecked ? "$primary" : "$textPrimary"}>
        {label}
      </TextBody>
    </Pressable>
  );
};

const sxUniCheckboxTagGroupStyles: { [key: string]: SxProp } = {
  container: {
    paddingX: 12,
    paddingY: 10,
  },
  optionsContainer: {
    flex: 1,
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "stretch",
  },
};

const sxUniCheckboxTagStyles: { [key: string]: SxProp } = {
  base: {
    minWidth: "31%",
    marginX: 4,
    marginY: 4,
    paddingY: 6.5,
    borderWidth: 1,
    borderRadius: 5,
    borderStyle: "solid",
    borderColor: "$borderPrimary",
    justifyContent: "start",
    alignItems: "center",
  },
  default: {},
  checked: {
    borderColor: "$primary",
    backgroundColor: "transparent",
  },
};
